/* Dalia Bella · ofertas por cantidad: la tarjeta elegida fija la cantidad del formulario y al revés. */
(function () {
  if (window.__dbPacks) return; window.__dbPacks = true;
  function campo() { return document.querySelector('product-form-component input[name="quantity"]') || document.querySelector('input[name="quantity"]'); }
  function marcar(n) {
    document.querySelectorAll('[data-db-packs] .db-pack').forEach(function (b) {
      var c = +b.dataset.cant, on = n >= 4 ? c === 4 : c === n;
      b.classList.toggle('is-on', on); b.setAttribute('aria-checked', on ? 'true' : 'false');
    });
  }
  function poner(n) {
    var i = campo(); if (!i) return;
    i.value = n;
    i.dispatchEvent(new Event('input', { bubbles: true }));
    i.dispatchEvent(new Event('change', { bubbles: true }));
  }
  var elegido = 1;
  document.addEventListener('click', function (e) {
    var b = e.target.closest('.db-pack');
    if (b) { elegido = +b.dataset.cant; marcar(elegido); poner(elegido); return; }
    if (e.target.closest('.quantity-minus, .quantity-plus')) setTimeout(function () { var i = campo(); if (i) { elegido = Math.max(1, parseInt(i.value, 10) || 1); marcar(elegido); } }, 60);
  });
  document.addEventListener('change', function (e) {
    if (e.target && e.target.name === 'quantity' && e.target.closest('product-form-component')) { elegido = Math.max(1, parseInt(e.target.value, 10) || 1); marcar(elegido); }
  });
  /* al cambiar de color o talla Horizon redibuja la ficha: se mantiene la cantidad elegida */
  var t;
  new MutationObserver(function () {
    clearTimeout(t);
    t = setTimeout(function () { var i = campo(); if (i && elegido > 1 && (parseInt(i.value, 10) || 1) !== elegido) poner(elegido); marcar(elegido); }, 120);
  }).observe(document.body, { childList: true, subtree: true });
})();
